import * as THREE from 'three'
import { useState, useEffect, useRef } from 'react'

import Panel from './Panel'

export default function MainPanel({ pages, pageIndex, videoRef }) {
  return (
    <>
      <Panel size={[2.8, 1.7]}></Panel>
      <VideoTexture url={pages[pageIndex].videoURL} videoRef={videoRef} />
    </>
  )
}

const VideoTexture = ({ url, videoRef }) => {
  const ref = useRef()
  const [hovered, setHovered] = useState(false)

  const over = () => setHovered(true)
  const out = () => setHovered(false)

  useEffect(() => {
    if (hovered) document.body.style.cursor = 'pointer'
    return () => (document.body.style.cursor = 'auto')
  }, [hovered])

  useEffect(() => {
    videoRef.current.src = url
    videoRef.current.load()
    videoRef.current.play()
  }, [url])

  useEffect(() => {
    if (videoRef.current) {
      const videoTexture = new THREE.VideoTexture(videoRef.current)
      videoTexture.needsUpdate = true
      ref.current.map = videoTexture
    }
  }, [videoRef])

  const handlePlayPause = () => {
    if (videoRef.current) {
      if (videoRef.current.paused) {
        videoRef.current.play()
      } else {
        videoRef.current.pause()
      }
    }
  }

  return (
    <mesh renderOrder={10} position={[0, 0, 0.002]} onClick={handlePlayPause} onPointerOver={over} onPointerOut={out}>
      <planeGeometry args={[2.6, 1.5, 20, 20]} />
      <meshBasicMaterial ref={ref} toneMapped={false} />
    </mesh>
  )
}
